"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.screens = void 0;
const layout_1 = require("@carbon/layout");
exports.screens = Object.entries(layout_1.breakpoints).reduce((acc, entry) => (Object.assign(Object.assign({}, acc), { 'pointer-coarse': { raw: '(pointer: coarse)' }, [entry[0]]: entry[1].width })), {});
